import { Collapse } from '@material-ui/core/'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styled from 'styled-components'

const PaperContainer = styled.div`
  display:flex;
  justify-content: center;
  flex-direction: column;
  background: #F9F9F9;
  width: 100%;
  border-radius: 10px;
  margin: 0 0 0.5em 0;
  border-radius: 10px;
  box-shadow: ${props => (props.enable ? '0px 3px 6px rgba(26, 26, 26, 0.12), 0px 0px 1px rgba(26, 26, 26, 0.24)' : "0px 0px 1px rgba(26, 26, 26, 0.24)")};
`

const MainRow = styled.div`
  display: flex;
  justify-content: space-between;
  opacity: ${props => (props.enable ? 1 : 0.5)};
`

const LeftRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.3em 1em;
`
const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
`

const Title = styled.div`
  color: #1b1b1b;
  margin-right: .7em;
  display: flex;
  align-items: flex-end;
  font-family: OpenSansBold;
  font-weight: bold;
  font-size: 17px;
  line-height: 23px;
  @media (max-width: 375px) {
    font-size: .88em;
  }
`

const SubTitle = styled.div`
  color: #F2C94C;
  font-size: .6em;
  text-transform: uppercase;
  display: flex;
  font-family: OpenSansLight;
  align-items: flex-end;
  @media screen and (max-width: 320px) {
    font-size: .5em;
  }
`
const ContainerDescripcion = styled.div`
  display: flex;
  flex-direction: row;
  letter-spacing: 0.005em;
  font-size: 15px;
  line-height: 20px;
  @media screen and (max-width: 390px) {
    font-size: 13px;
  }
  @media screen and (max-width: 330px) {
    font-size: 12px;
  }
`
const SubCud = styled.div`
  display: flex;
  flex-direction: column;
`

const Quantity = styled.div`
  color: #FF6868;
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.01em;
  margin-left: 8px;
  @media screen and (max-width: 390px) {
    font-size: 13px;
  }
  @media screen and (max-width: 330px) {
    font-size: 12px;
  }
`

const HomeIcon = styled.img`
  height: 12px;
  width: 12px;
  margin-right: .1em;
  margin-left: .8em;
`
const ShowContainer = styled.div`
  margin-top: .8em;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`
const EyeIcon = styled.img`
  height: .9em;
  width: .9em;
  margin-right: .5em;
`
const ShowTxt = styled.span`
  color: #ffffff;
  font-size: .7em;
  font-family: OpenSansLight;
`

const RightRow = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  background: var(--main-primary-color);
  background: ${props => (props.enable ? 'var(--main-primary-color)' : "var(--main-gray-color)")};
  padding: 0px 0.7rem;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
`
const ImageArrowRight = styled.img`
  height: 1.3em;
  width: 1.3em;
  @media screen and (max-width: 320px) {
    width: 1em;
    height: 1em
  }
`
const DetailRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1em;
`
const DetailTitle = styled.div`
  color: #F2C94C;
  font-family: OpenSansBold;
  font-size: .9em;
`
const DetailList = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column;
  margin-top: .8em;
  max-height: 10em;
  &::-webkit-scrollbar {
    width: .2em;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent !important;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(196, 196, 196, 0.35) !important;
    border-radius: 4px;
  }
`

const DetailItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: .3em;
`
const CircleItem = styled.div`
  height: 7px;
  width: 7px;
  border-radius: 80px;
  background-color: #ffffff;
  margin-right: 1.4em;
  @media screen and (max-width: 360px) {
    margin-right: .8em
  }
`
const DetailTxt = styled.span`
  font-size: .8em;
  color: #ffffff;
`


const CustomPaper = ({ title, description, quantity, enable, details = [], onClick }) => {

  const [showDetails, setShowDetails] = useState(false)

  return (
    <PaperContainer enable={enable}>
      <MainRow enable={enable}>
        <LeftRow >
          <TitleContainer>
            <Title>{title}</Title>
            {details.length <= 0 &&
              <ContainerDescripcion><SubCud>{description} </SubCud>
                <Quantity>{quantity}</Quantity>
              </ContainerDescripcion>}
          </TitleContainer>
          {details.length > 0 &&
            <ShowContainer onClick={() => setShowDetails(!showDetails)}>
              <EyeIcon src={require('../../../../assets/images/eye-icon.svg')} />
              <ShowTxt>{showDetails ? 'Ocultar detalles' : 'Ver detalles'}</ShowTxt>
            </ShowContainer>
          }
        </LeftRow>
        <RightRow enable={enable} onClick={onClick}>
          <ImageArrowRight src={require('../../../../assets/images/arrow-right.svg')} />
        </RightRow>
      </MainRow>
      <Collapse in={(showDetails && details.length > 0)}>
        <DetailRow>
          <DetailTitle>PRODUCTOS</DetailTitle>
          <DetailList>
            {
              details.map(d => (
                <DetailItem>
                  <CircleItem />
                  <DetailTxt>{d.id}</DetailTxt>
                  <HomeIcon src={require('../../../../assets/images/house-icon.svg')} />
                  <SubTitle>{d.location}</SubTitle>
                </DetailItem>
              ))
            }
          </DetailList>
        </DetailRow>
      </Collapse>
    </PaperContainer>
  )
}

CustomPaper.defaultProps = {
  title: 3171861434,
  description: ''
}

CustomPaper.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.func
  ]),
  description: PropTypes.string,
  details: PropTypes.array
}

export default CustomPaper
